/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-12 09:11:18
 * @LastEditTime: 2023-10-30 17:58:36
 * @LastEditors: youqifa youqifa@yxj.org.cn
 */

// 新接口
import axios from 'axios'
import Encode from './encode'
import storage from 'storejs'
import store from './../../store'
import { toLoginByAppOrH5 } from './../../utils/loginByAppOrH5'

export const apiYsz = function (url, body, platform, method, buriedPointReset, otherParams) {
  const CancelToken = axios.CancelToken
  const YszAppInfo = JSON.parse(localStorage.getItem('YszAppInfo'))
  console.log('YszAppInfo', YszAppInfo)
  const data = {
    'brand': '',
    'guid': YszAppInfo&&YszAppInfo.guid ? YszAppInfo.guid : window.uuid, // 必传
    'model': '',
    'platform': (YszAppInfo&&YszAppInfo.platform) || 'WeChat',
    'sysVersion': '',
    'time': parseInt(+new Date() / 1000),
    'uid': YszAppInfo&&YszAppInfo.uid ? YszAppInfo.uid : -1, // 必传
    'version': YszAppInfo&&YszAppInfo.version ? YszAppInfo.version : '5.9.0', // 必传
    'session':YszAppInfo&&YszAppInfo.session ? YszAppInfo.session : '',
    'body': body
  }
  if (buriedPointReset) {
    data.buriedPointReset = {}
    if (buriedPointReset.isMain) {
      data.buriedPointReset.isMain = buriedPointReset.isMain
    }
    if (buriedPointReset.searchSource) {
      data.buriedPointReset.searchSource = Number(buriedPointReset.searchSource)
    }
  }
  console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', data)
  console.log(`%c 请求：${url}`, 'color: blue;font-size: 16px', body)
  let sendData = Encode.encodeFunc(data)
  return new Promise((resolve, reject) => {
    axios({
      method: method || 'post',
      url: window.API_ROOT_YSZ + url,
      data: sendData,
      // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
      // 如果请求话费了超过 `timeout` 的时间，请求将被中断
      timeout: (otherParams && otherParams.timeout) ? otherParams.timeout : 0,
      cancelToken: new CancelToken(function executor (cancel) {
        // 2.将cancel token存入列表
        if (url === 'content/searchDrugUnion' || url === 'content/searchDrugTaboo') {
          window.axiosPromiseArr.push({ cancel })
          console.log(window.axiosPromiseArr)
        }
      })
    })
      .then((res) => {
        // console.log(res);
        let getData = res.data
        let decodeGetData = JSON.parse(Encode.decodeFuc(getData.data)) // 解密data   获取的是字符串
        // let toAes = Encode.encodeFunc(decodeGetData) // 对解密的数据加密
        console.log(`%c 响应：${url}`, 'color: green;font-size:16px;', decodeGetData)
        if (decodeGetData.code === 200) {
          resolve(decodeGetData.body)
        } else if (decodeGetData.code === 999) {
          toLoginByAppOrH5()
          resolve(decodeGetData.body)
        } else if ((decodeGetData.code == 607 || decodeGetData.code == 610) && url === 'user/registerLogin') {
          resolve(decodeGetData.body)
        } else {
          const timeError = {
            msg: decodeGetData.msg,
            data: decodeGetData,
            code: decodeGetData.code
          }
          reject(timeError)
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('请求取消')
        } else {
          console.log(err)
          let error = {
            msg: '服务器开小差啦'
          }
          console.debug(err)
          reject(error)
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/server/api/apiYsz.js